import React from "react";

export function ConfirmationDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  isDestructive = false,
  isLoading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="integrations-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="integrations-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="integrations-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id="integrations-dialog-title" className="integrations-dialog-title">
          {title}
        </h3>
        <p className="integrations-dialog-message">{message}</p>
        <div className="integrations-dialog-actions">
          <button
            type="button"
            className="integrations-btn integrations-btn-secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`integrations-btn ${
              isDestructive ? "integrations-btn-danger" : "integrations-btn-primary"
            }`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Working..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
